import { router, setPageContent } from "..";
import { registerFarmcamSim } from "../api/users_{userId}_farmcam-sim";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import { onMobile, scanBarcode } from "../mobile";
import { state } from "../state";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";
import { MaterialDesign } from "../view/material_design";

/**
 * @type {import("navigo").Handler}
 */
function registerFarmcamSimPage(ctx) {
	const scan = () => {
		scanBarcode(t.farmcamSim.addDevicePage.scanImsiBarcodePrompt).then(
			(code) => {
				if (!code) return;
				imsi.setValue(code);
			},
		);
	};

	const imsi = Bulma.input({
		type: "text",
	});

	const name = Bulma.input({
		type: "text",
	});

	setPageContent(
		centeredBox(
			"small",
			Bulma.level(
				Bulma.levelLeft(
					Bulma.levelItem(
						Bulma.title(t.farmcamSim.addDevicePage.header, "is-4"),
					),
				),
				Bulma.levelRight(
					Bulma.levelItem(
						MaterialDesign.icon({
							id: "help",
							onClick: () => window.open(t.supportUrl, "_blank"),
						}),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label("IMSI"),
				Bulma.field(
					{
						styles: onMobile ? ["has-addons"] : undefined,
					},
					Bulma.control(
						{
							styles: ["is-expanded"],
						},
						imsi.element,
					),
					Bulma.control(
						{
							hidden: !onMobile,
						},
						Bulma.button(
							{
								onClick: scan,
							},
							MaterialDesign.icon({
								id: "barcode",
								alignment: "right",
							}),
						),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label(t.device.addDevicePage.chooseNamePrompt),
				Bulma.control({}, name.element),
			),
			Bulma.field(
				{
					styles: ["is-grouped"],
				},
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: onClickRegister,
							styles: ["is-primary"],
						},
						t.add,
					),
				),
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: () => router.jump("/devices/register"),
							styles: ["is-primary"],
						},
						t.back,
					),
				),
			),
		),
	);

	async function onClickRegister() {
		const promise = registerFarmcamSim(imsi.getValue(), name.getValue());
		const fcs = await loadingScreen.waitFor(promise);
		state.farmcamSims[fcs.Imsi] = fcs;
		router.jump(`/devices?id=${fcs.Imsi}`);
	}
}

export { registerFarmcamSimPage };
